export default __webpack_public_path__ + "static/calvert.3288283ae6be98ca7fde76972b4c1a94.png";